import { useEffect } from "react";
import { Link } from "react-router-dom";
import useInfinite from "../../hooks/useInfinite";

const NoticeList = (props) => {
  const headerUi = {
    goback: true,
    closeAll: false,
  };
  const pageName = "공지사항";

  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);
  const data = useInfinite({
    url: "/v1/notice",
    listSize: 50,
  });

  return (
    <div className="container qna terms_list_wrap">
      <div className="faq_list_wrap">
        {data !== null || (data && data.length > 0) ? (
          <div className="faq_lists">
            {data &&
              data.map((item) => {
                return (
                  <Link
                    to={`/notice/${item.id}`}
                    key={item.id}
                    className="faq_list"
                  >
                    <span className="txt_wrap">
                      <span className="faq_list_txt">{item.title}</span>
                    </span>
                    <img src="./img/Right.svg" alt="상세보기" />
                  </Link>
                );
              })}
          </div>
        ) : (
          <div className="no_list">
            <h5>공지사항 내역이 없습니다.</h5>
          </div>
        )}
      </div>
    </div>
  );
};
export default NoticeList;
